import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { getCellAttrs, getCellDomAttrs } from '@atlaskit/adf-schema';
import TableNodeView from './TableNodeViewBase';
var DEFAULT_COL_SPAN = 1;
var DEFAULT_ROW_SPAN = 1;
var TableCell = /*#__PURE__*/function (_ref) {
  _inherits(TableCell, _ref);
  var _super = _createSuper(TableCell);
  function TableCell(node, view, getPos, eventDispatcher) {
    _classCallCheck(this, TableCell);
    return _super.call(this, node, view, getPos, eventDispatcher);
  }
  _createClass(TableCell, [{
    key: "update",
    value: function update(node) {
      var didUpdate = this.updateNodeView(node);
      if (didUpdate) {
        this.node = node;
      }
      return didUpdate;
    }
  }, {
    key: "updateNodeView",
    value: function updateNodeView(node) {
      var _this = this;
      if (this.node.type !== node.type) {
        return false;
      }
      var attrs = getCellDomAttrs(this.node);
      var nextAttrs = getCellDomAttrs(node);
      var _getCellAttrs = getCellAttrs(this.dom),
        colspan = _getCellAttrs.colspan,
        rowspan = _getCellAttrs.rowspan;

      // need to rerender when colspan/rowspan in dom are different from the node attrs
      // this can happen when undoing merge cells
      if (colspan !== (node.attrs.colspan || DEFAULT_COL_SPAN) || rowspan !== (node.attrs.rowspan || DEFAULT_ROW_SPAN)) {
        return false;
      }

      // added + changed attributes
      var addedAttrs = Object.entries(nextAttrs).filter(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
          key = _ref3[0],
          value = _ref3[1];
        return attrs[key] !== value;
      });
      var removedAttrs = Object.keys(attrs).filter(function (key) {
        return !nextAttrs.hasOwnProperty(key);
      });
      if (addedAttrs.length || removedAttrs.length) {
        addedAttrs.forEach(function (_ref4) {
          var _ref5 = _slicedToArray(_ref4, 2),
            key = _ref5[0],
            value = _ref5[1];
          return _this.dom.setAttribute(key, value || '');
        });
        removedAttrs.forEach(function (key) {
          return _this.dom.removeAttribute(key);
        });
        return true;
      }

      // Return true to not re-render this node view
      if (this.node.sameMarkup(node)) {
        return true;
      }
      return false;
    }
  }]);
  return TableCell;
}(TableNodeView);
export { TableCell as default };